// The `<nav class="auth-nav">` every auth screen opens with, ported from the repeated block
// in login/sign-up/verify/status/user/forgot-password/reset-password/enable-cookies/
// out-of-date templates. Upstream duplicates it per template; it is one component here
// because the duplication was incidental, not a design.
import { Link } from 'react-router-dom'
import type { ReactElement } from 'react'
import { asset } from '../assetBase.ts'

export interface AuthNavProps {
  /** Upstream's `ctrl.admin`, which adds `is-admin` to the nav. */
  admin?: boolean
  /** Most screens link the logo to `^.status`; enable-cookies deliberately does not. */
  linkTo?: string | null
  /** Upstream sets `active` when the current state is the login state specifically. */
  active?: boolean
}

/**
 * `cdn-src` upstream resolves against the CDN host. Here the path is used as-is and reaches
 * the tenant through the proxy, which serves `/static/**` (§3) — so the image is the same
 * byte-for-byte asset production serves, which is what the pixel diff requires.
 */
const LOGO_SRC = '/static/assets/img/extension/logo.png'

export function AuthNav({ admin = false, linkTo = '/chrome-extension/auth/status', active = false }: AuthNavProps): ReactElement {
  // `alt=""` is right for a DECORATIVE image and wrong here whenever the logo is a link's
  // only content: the link then has no accessible name at all, so a screen reader announces
  // "link" and nothing else. Upstream has the same gap; giving the image its name is
  // pixel-neutral, unlike restructuring the link.
  const logo = <img className="logo" src={asset(LOGO_SRC)} alt={linkTo === null ? '' : 'Woo'} />

  return (
    <nav className={['auth-nav', admin ? 'is-admin' : ''].filter(Boolean).join(' ')}>
      {linkTo === null ? (
        <a className="logo-btn">{logo}</a>
      ) : (
        <Link className={['logo-btn', active ? 'active' : ''].filter(Boolean).join(' ')} to={linkTo}>
          {logo}
        </Link>
      )}
    </nav>
  )
}
